import { ROUTES } from "../routes";

import { FinalCTASection } from "./FinalCTA";

export default function PurchaseFinalCTA() {
  return (
    <FinalCTASection
      text="What will you design?"
      subtext="Join thousands of people designing with Flowstep"
      primaryButton={{
        text: "Start for free",
        subtext: "No credit card required",
        route: ROUTES.register,
      }}
      secondaryButton={{
        text: "See Pricing",
        route: ROUTES.pricing,
      }}
    />
  );
}
